<template>
  <div>
    <div class="modal fade show" style="display: block;">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">
              Zmienione w
              <span v-if="client.old.modifier">CRM: {{ client.old.modifier }}</span>
              <span v-if="client.old.branchName">PLAZA: {{ client.old.branchName }}</span>
              ( {{ client.old.modificationDate | datetime }})
            </h4>
            <button class="close" type="button" @click="close()" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <table class="table table-striped table-sm">
                  <thead>
                  <tr>
                    <th>Pole</th>
                    <th>Poprzednia wartość</th>
                    <th>Nowa wartość</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(value, key) in client.old.data" v-bind:key="key"
                      :class="{ 'table-success': value !== client.new.data[key] }">
                    <td>{{ $t('clients.field.label.' + key)}}</td>
                    <td>
                      <span v-if="key === 'actualLoyaltyGroup'">
                        {{ $t('loyaltyCards.level.' + value)}}
                      </span>
                      <span v-else-if="key === 'applicableLoyaltyGroup'">
                        {{ $t('loyaltyCards.level.' + value)}}
                      </span>
                      <span v-else-if="key === 'loyaltyBalance'">
                        {{ value | currency }}
                      </span>
                      <span v-else-if="key === 'initialLoyaltyBalance'">
                        {{ value | currency }}
                      </span>
                      <span
                          v-else-if="key === 'isActive' || key === 'zgodaNpdo' || key === 'zgodaNprd' || key === 'zgodaEmail' || key === 'zgodaNoih'">
                        {{ value ? 'TAK' : 'NIE' }}
                      </span>
                      <span v-else-if="key === 'modificationDate' || key === 'creationDate'">
                        {{ value | datetime }}
                      </span>
                      <span v-else>{{ value }}</span>
                    </td>
                    <td>
                       <span v-if="key === 'actualLoyaltyGroup'">
                        {{ $t('loyaltyCards.level.' + client.new.data[key])}}
                      </span>
                      <span v-else-if="key === 'applicableLoyaltyGroup'">
                        {{ $t('loyaltyCards.level.' + client.new.data[key])}}
                      </span>
                      <span v-else-if="key === 'loyaltyBalance'">
                        {{ client.new.data[key] | currency }}
                      </span>
                      <span v-else-if="key === 'initialLoyaltyBalance'">
                        {{ client.new.data[key] | currency }}
                      </span>
                      <span
                          v-else-if="key === 'isActive' || key === 'zgodaNpdo' || key === 'zgodaNprd' || key === 'zgodaEmail' || key === 'zgodaNoih'">
                        {{ client.new.data[key] ? 'TAK' : 'NIE' }}
                      </span>
                      <span v-else-if="key === 'modificationDate' || key === 'creationDate'">
                        {{ client.new.data[key] | datetime }}
                      </span>
                      <span v-else>{{ client.new.data[key] }}</span>
                    </td>
                  </tr>
                  <tr v-bind:class="{ 'table-success': client.old.data.parentClientId !== client.new.data.parentClientId }">
                    <td>Status</td>
                    <td>
                      {{ client.old.data.parentClientId ? 'Subkonto' : 'Konto główne' }}
                    </td>
                    <td>
                      {{ client.new.data.parentClientId ? 'Subkonto' : 'Konto główne' }}
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-backdrop fade show"></div>
  </div>
</template>

<script>
  import ClientDetailsCard from '@Component/client-details-card';

  export default {
    props: [
      'client',
    ],
    components: {
      ClientDetailsCard,
    },
    methods: {
      close() {
        this.$emit('closed');
      },
    },
  };
</script>
